module.exports = __webpack_public_path__ + "static/media/discord.aa4132ab.png";